import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {POLL_INTERVAL} from '../../constants';
import {gqlPaginatorInfo, PaginatiorInfo} from '../../graphql/common.datatypes';
import {WcvDocument} from '../../graphql/documents.datatypes';
import {gqlDocument} from './getDocument.api';

interface DocumentsData {
    documents: {
        data: WcvDocument[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const GET_DOCUMENTS_QUERY = gql`
    query getDocuments($count: Int!, $page: Int!, $where: WhereConditions, $orderBy: [OrderByClause!]){
        documents(first: $count, page: $page, where: $where, orderBy: $orderBy){
            data {
                ${gqlDocument}
            }
            ${gqlPaginatorInfo}
        }
    }
`;

export const getDocuments = (count: number, page: number, where?: any, orderBy?: any) => useQuery<DocumentsData>(
    GET_DOCUMENTS_QUERY,
    {
        variables: {
            count,
            page,
            where,
            orderBy,
        },

    }
);

export default getDocuments;
